/**
 * The kikik chip: a counter you could pick up.
 *
 * A jade token with three ivory dots arranged the way pips sit on a Mahjong
 * dot tile - the platform's own piece, not a generic logo shape. Drawn once
 * here and reused by the header, the footer and the table's exit link.
 */

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      className={`chip ${className ?? ""}`}
      viewBox="0 0 40 40"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="1.5" y="1.5" width="37" height="37" rx="12" className="chip__body" />
      <rect x="5" y="5" width="30" height="30" rx="9" className="chip__inlay" />
      <circle cx="20" cy="12.5" r="3.6" className="chip__pip" />
      <circle cx="13.5" cy="25.5" r="3.6" className="chip__pip" />
      <circle cx="26.5" cy="25.5" r="3.6" className="chip__pip" />
    </svg>
  );
}
